import type { LocationQuery } from 'vue-router';

export const useProductListing = (page: Record<string, any>) => {
  const route = useRoute();
  const cartStore = useCartStore();

  const loading = ref(false);

  const handleFilter = async (facetOrFacets: any) => {
    loading.value = true;

    let query: LocationQuery = {};

    if (route.query.q || route.query.text || route.query.sort) {
      query = route.query;
    }

    const solrQuery = getFilteredSolrString(query, page.content?.config?.filters, facetOrFacets);
    const solrQueryHasContent = solrQuery !== '::';

    return navigateTo({
      path: route.path,
      query: solrQueryHasContent
        ? {
            q: solrQuery,
            text: query?.text,
            sort: query?.sort,
          }
        : {},
    });
  };

  const handleGoToPage = async (currentPage: number) => {
    loading.value = true;

    return navigateTo({
      path: route.path,
      query: {
        q: route.query.q,
        text: route.query.text,
        sort: route.query.sort,
        currentPage,
      },
    });
  };

  const handleSorting = async (sort: string) => {
    loading.value = true;

    return navigateTo({
      query: {
        q: route.query.q,
        text: route.query.text,
        sort,
      },
    });
  };

  const handleAddToCart = async ({ productCode, quantity }: any) => {
    return cartStore.addEntry({ productCode, quantity });
  };

  return {
    handleFilter,
    handleGoToPage,
    handleSorting,
    handleAddToCart,
  };
};
